const texts = {
  en: {
    text: 'Information not yet registered.',
  },
  sp: {
    text: 'Información no registrada aún.',
  }
}

export default texts;